import styled from "styled-components";

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-start;
	gap: 1rem;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 1rem;

	> ${AreaButtons} {
		grid-column: 1 / 4;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		grid-template-columns: repeat(2, 1fr);

		> ${AreaButtons} {
			grid-column: auto;
		}
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		grid-template-columns: 1fr;

		> ${AreaButtons} {
			flex-direction: column;

			> button {
				width: 100%;
				max-width: 100%;
			}
		}
	}
`;
